import mensClothingImgURl from '../../../images/portfolio/web-images/ui-template/mens-clothing.jpg';
import saudiBellImgURl from '../../../images/portfolio/web-images/ui-template/saudi-bell.jpg';
import cafeHouseImgURl from '../../../images/portfolio/web-images/ui-template/cafe-house.jpg';
import omniFoodImgURl from '../../../images/portfolio/web-images/ui-template/omni-food.jpg';
import freshFishImgURl from '../../../images/portfolio/web-images/ui-template/fresh-fish.jpg';
import furnishImgURl from '../../../images/portfolio/web-images/ui-template/furnish.jpg';
import natoursImgURl from '../../../images/portfolio/web-images/ui-template/natours.jpg';
import chairImgURl from '../../../images/portfolio/web-images/ui-template/chair.jpg';

const uiTemplateList = [
  {
    imgUrl: mensClothingImgURl,
    title: "Men's Clothing",
    githubUrl: 'https://github.com/amrsaadabdallah/my-mens-clothing',
    infoUrl: 'https://github.com/amrsaadabdallah/mens-clothing',
    liveUrl: 'https://amrsaadabdallah.github.io/mens-clothing',
    type: 'large',
  },
  {
    imgUrl: saudiBellImgURl,
    title: 'Saudi Bell',
    githubUrl: 'https://github.com/amrsaadabdallah/my-saudi-bell',
    infoUrl: 'https://github.com/amrsaadabdallah/saudi-bell',
    liveUrl: 'https://amrsaadabdallah.github.io/saudi-bell',
    type: 'large',
  },
  {
    imgUrl: cafeHouseImgURl,
    title: 'Cafe House',
    githubUrl: 'https://github.com/amrsaadabdallah/my-cafe-house',
    infoUrl: 'https://github.com/amrsaadabdallah/cafe-house',
    liveUrl: 'https://amrsaadabdallah.github.io/cafe-house',
    type: 'large',
  },
  {
    imgUrl: omniFoodImgURl,
    title: 'Omni Food',
    githubUrl: 'https://github.com/amrsaadabdallah/my-omni-food',
    infoUrl: 'https://github.com/amrsaadabdallah/omni-food',
    liveUrl: 'https://amrsaadabdallah.github.io/omni-food',
    type: 'large',
  },
  {
    imgUrl: freshFishImgURl,
    title: 'Fresh Fish',
    githubUrl: 'https://github.com/amrsaadabdallah/my-fresh-fish',
    infoUrl: 'https://github.com/amrsaadabdallah/fresh-fish',
    liveUrl: 'https://amrsaadabdallah.github.io/fresh-fish',
    type: 'large',
  },
  {
    imgUrl: furnishImgURl,
    title: 'Furnish',
    githubUrl: 'https://github.com/amrsaadabdallah/my-furnish',
    infoUrl: 'https://github.com/amrsaadabdallah/furnish',
    liveUrl: 'https://amrsaadabdallah.github.io/furnish',
    type: 'large',
  },
  {
    imgUrl: natoursImgURl,
    title: 'Natours',
    githubUrl: 'https://github.com/amrsaadabdallah/my-natours',
    infoUrl: 'https://github.com/amrsaadabdallah/natours',
    liveUrl: 'https://amrsaadabdallah.github.io/natours',
    type: 'large',
  },
  {
    imgUrl: chairImgURl,
    title: 'Chair',
    githubUrl: 'https://github.com/amrsaadabdallah/my-chair',
    infoUrl: 'https://github.com/amrsaadabdallah/chair',
    liveUrl: 'https://amrsaadabdallah.github.io/chair',
    type: 'large',
  },
];

export default uiTemplateList;
